import adminMiddleware from "@/components/tasks/admin/ducks/middleware"
import userMiddleware from "@/components/tasks/ducks/middleware"

export default [userMiddleware, adminMiddleware]
